import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static values = {
		active: Boolean,
	};

	connect() {
		this.onFavoritesChanged = this.onFavoritesChanged.bind(this);
		document.addEventListener('study:favorites-changed', this.onFavoritesChanged);
		this.applyState(this.hasActiveValue ? this.activeValue : false);
	}

	disconnect() {
		document.removeEventListener('study:favorites-changed', this.onFavoritesChanged);
	}

	onFavoritesChanged(event) {
		if (typeof event?.detail?.hasFavorites === 'boolean') {
			this.applyState(event.detail.hasFavorites);
			return;
		}

		const action = event?.detail?.favoriteAction;
		if (action === 'add') {
			this.applyState(true);
			return;
		}

		if (action === 'remove') {
			this.applyState(false);
		}
	}

	applyState(isActive) {
		this.activeValue = Boolean(isActive);
		this.element.classList.toggle('text-red', this.activeValue);
		this.element.classList.toggle('text-white/70', !this.activeValue);
	}
}
